import { render, staticRenderFns } from "./StackedColumnPie.vue?vue&type=template&id=df820ffa&"
import script from "./StackedColumnPie.vue?vue&type=script&lang=js&"
export * from "./StackedColumnPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports